import { FC } from 'react';

import { DataLink } from 'components/Shared/SharedComponents';

import styles from './styles.module.scss';

import type { ISignInButtonMobile } from '../config/declarations';

const SignInButtonMobile: FC<ISignInButtonMobile> = ({ auth }) => {
  if (!auth) {
    return null;
  }

  const { signIn } = auth;

  if (!signIn) {
    return null;
  }

  return (
    <DataLink link={signIn} className={styles.signIn}>
      {signIn.title}
    </DataLink>
  );
};

export default SignInButtonMobile;
